const LoadingSpinner = () => {
  return <div className="spinner" />;
};

export default LoadingSpinner;
